import { render, staticRenderFns } from "./courseReview.vue?vue&type=template&id=194e34ee&scoped=true&"
import script from "./courseReview.vue?vue&type=script&lang=js&"
export * from "./courseReview.vue?vue&type=script&lang=js&"
import style0 from "./courseReview.vue?vue&type=style&index=0&id=194e34ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e34ee",
  null
  
)

export default component.exports